<div class="modal-dialog modal-xl mt-0 mb-0" role="document">
  <div class="modal-content" style="min-height: 450px;">
    <div class="modal-body">
      <button type="button" aria-label="Close" (click)="close()" class="btn-close btn-danger float-end">
      </button>

      <div class="col-lg-12 col-md-12 col-sm-12 mb-4">
        <h4 class="titulo_seccao">Laudo PMG</h4>
      </div>

      <form [formGroup]="resourceForm">
        <app-input-field-hide formControlName="id"></app-input-field-hide>
        <div class="row mb-3">
          <div class="col-md-3">
            <div class="form-group">
              <label class="fw-bold">Tipo de Veículo:</label>
              <select formControlName="tipoVeiculo" (change)="carregarPerguntas()" class="form-select"
                [disabled]="!resourceForm.get('id')?.value"
                [class.is-invalid]="resourceForm.get('tipoVeiculo').touched && resourceForm.get('tipoVeiculo').invalid">
                <option *ngFor="let tipo of tiposVeiculo" [value]="tipo.value">{{ tipo.label }}</option>
              </select>
            </div>
          </div>
          
          <div class="col-md-3">
            <label class="fw-bold">Classificação</label>
             <div class="alert text-center" [ngClass]="{
               'alert-success': classificacaoDano === 'Pequena Monta',
               'alert-warning': classificacaoDano === 'Média Monta',
               'alert-danger': classificacaoDano === 'Grande Monta'
             }" style="padding: 5px; margin-bottom: 0;">
                <h5 class="mb-0"><strong>{{ classificacaoDano }}</strong></h5>
             </div>
          </div>
        
          <div class="col-md-2">
            <label class="fw-bold">Situação</label>
             <div class="alert text-center" [ngClass]="{
               'alert-info': !resourceForm.get('id')?.value,
               'alert-warning': resourceForm.get('id')?.value
             }" style="padding: 5px; margin-bottom: 0;">
                <h5 class="mb-0 fw-bold">{{ resourceForm.get('id')?.value ? 'Alteração' : 'Criação' }}</h5>
             </div>
          </div>

            <div class="col-md-4 d-flex gap-2 pt-3">
                <button type="button" 
                        class="btn btn-outline-danger" 
                        [disabled]="!resourceForm.get('id')?.value"
                        (click)="remover()" 
                        title="Excluir este laudo permanentemente">
                    <i class="fa fa-trash me-1"></i> Remover
                </button>

                <button type="button" 
                        class="btn btn-outline-secondary" 
                        (click)="clear()"
                        title="Limpar todos os campos e iniciar novo formulário">
                    <i class="fa fa-eraser me-1"></i> Novo
                </button>
                            <button type="button" 
                        class="btn btn-primary" 
                        [ngClass]="{'disabled': !resourceForm.get('id')?.value }"
                        (click)="openRelatorio()"
                        title="Relatório">
                    <i class="fa fa-print me-1"></i> Relatório
                </button>
            </div>
        </div>

        <div class="row">
            <div class="col-md-8 table-responsive" style="/*max-height: 60vh;*/ overflow-y: auto;">
            <table class="table table-sm table-hover mt-2 laudopmmg">
                <thead class="table-light" style="position: sticky; top: 0; z-index: 1;">
                <tr>
                    <th style="width: 50px;">Item</th>
                    <th>Descrição dos Componentes</th>
                    <th *ngIf="resourceForm.get('tipoVeiculo')?.value === 'Caminhão' || resourceForm.get('tipoVeiculo')?.value === 'Cavalo Mecânico'">Valor</th>
                    <th class="text-center" style="width: 200px;">Dano</th>
                </tr>
                </thead>
                <tbody formArrayName="itens">
                <tr *ngFor="let control of itensControls; let i = index" [formGroupName]="i">
                    <td class="align-middle text-center">{{ control.get('item')?.value }}</td>
                    <td class="align-middle text-wrap">{{ control.get('descricao')?.value }}</td>
                    
                    <td *ngIf="resourceForm.get('tipoVeiculo')?.value === 'Caminhão' || resourceForm.get('tipoVeiculo')?.value === 'Cavalo Mecânico' || resourceForm.get('tipoVeiculo')?.value === 'Ônibus'" class="align-middle text-center">
                    <strong>{{ control.get('valor')?.value }}</strong>
                    </td>

                    <td class="align-middle text-center">
                    <div class="btn-group btn-group-sm" role="group">
                        <input type="radio" class="btn-check" formControlName="dano" value="SIM" [id]="'sim'+i" (change)="calcularClassificacao()">
                        <label class="btn btn-outline-danger" [for]="'sim'+i">SIM</label>

                        <input type="radio" class="btn-check" formControlName="dano" value="NÃO" [id]="'nao'+i" (change)="calcularClassificacao()">
                        <label class="btn btn-outline-success" [for]="'nao'+i">NÃO</label>

                        <input type="radio" class="btn-check" formControlName="dano" value="NA" [id]="'na'+i" (change)="calcularClassificacao()">
                        <label class="btn btn-outline-secondary" [for]="'na'+i">N/A</label>
                    </div>
                    </td>
                </tr>
                </tbody>
            </table>
            </div>     
            <div class="col-md-4">
                <div class="row">
                    <div *ngFor="let img of imagensReferencia; let i = index" class="col-12 mb-3">
                        <div class="card shadow-sm border-info">
                            <div class="card-header py-1 text-white text-center">
                                <span class="small fw-bold">Imagem {{ i + 1 }}</span>
                            </div>
                            <div class="card-body p-1 text-center bg-white" style="border-radius: 5px;">
                                <img [src]="img" 
                                    class="img-fluid rounded" 
                                    style="max-height: 250px; object-fit: contain;" 
                                    [alt]="'Referência ' + (i + 1)">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
   
        </div>

        <div class="card mt-4 mb-4 border-primary">
            <div class="card-header text-white">
                <h5 class="mb-0">Informações adicionais e observações</h5>
            </div>
            <div class="card-body bg-light" style="border-radius: 5px;">
                <div class="row">
                <div class="col-md-6 mb-3">
                    <label class="form-label fw-bold">Nome do agente</label>
                    <input type="text" class="form-control" formControlName="nomeAgente" placeholder="Digite o nome completo"
                    [class.is-invalid]="resourceForm.get('nomeAgente').touched && resourceForm.get('nomeAgente').invalid">
                </div>

                <div class="col-md-6 mb-3">
                    <label class="form-label fw-bold">Nome BAT</label>
                    <input type="text" class="form-control" formControlName="numeroBat" placeholder="Digite o número BAT"
                    [class.is-invalid]="resourceForm.get('numeroBat').touched && resourceForm.get('numeroBat').invalid">
                </div>

                <div class="col-md-6 mb-3">
                    <label class="form-label fw-bold">Registro/matrícula agente</label>
                    <input type="text" class="form-control" formControlName="registroMatricula"
                    [class.is-invalid]="resourceForm.get('registroMatricula').touched && resourceForm.get('registroMatricula').invalid">
                </div>
                <div class="col-md-6 mb-3">
                    <label class="form-label fw-bold">Nº do BO acidente</label>
                    <input type="text" class="form-control" formControlName="numeroBO" 
                    [class.is-invalid]="resourceForm.get('numeroBO').touched && resourceForm.get('numeroBO').invalid">
                </div>

                <div class="col-md-12">
                    <label class="form-label fw-bold">Observação</label>
                    <textarea class="form-control" formControlName="observacao" rows="3"></textarea>
                </div>
                </div>
            </div>
        </div>
      </form>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-success" (click)="salvar()">
        <i class="fa fa-check"></i> Confirmar Laudo
      </button>
      <button type="button" class="btn btn-light" (click)="bsModalRef.hide()">Cancelar</button>
    </div>
  </div>
</div>